import { Link } from 'react-router-dom'
import { FC } from 'react'
import { AUTH_PATH } from '~/app/lib/paths'
import Icon from '../../utils/Icon'
import Text from '../../utils/Text/Text'

const ResetSuccessful: FC = () => {
  return (
    <div className="flex flex-col items-center gap-14">
      <div className="flex flex-col items-center gap-5">
        <Icon name="tick-circle" size={64} color="var(--primary)" />
        <Text type="headline-4" color="800">
          Reset password successfully!
        </Text>
        <Text type="body-1" color="600">
          You have changed your password.
        </Text>
      </div>
      <Link to={AUTH_PATH.SIGN_IN} className="flex items-center">
        <Icon name="arrow-left-2" color="var(--primary)" size={24} className="mr-2" />
        <Text type="title-2" color="primary">
          Back to Sign in
        </Text>
      </Link>
    </div>
  )
}

export default ResetSuccessful
